module.exports = __webpack_public_path__ + "static/img/home_42.321f8c34.png";